import { useState } from 'react';

const MARKETS = [
  {
    country: { name: 'Deutschland', code: 'DE' as const },
    language: { name: 'Deutsch', code: 'de' as const },
    redirectInfo: {
      text: 'Wir können dich auf unseren deutschen Marktführer billiger-mietwagen.de weiterleiten, damit du dein bestes Angebot findest.',
      header: 'Weiterleiten',
      link: {
        text: 'Zu billiger-mietwagen.de',
        url: 'https://www.billiger-mietwagen.de',
      },
    },
  },
  {
    country: { name: 'Frankreich', code: 'FR' as const },
    language: { name: 'Französisch', code: 'fr' as const },
    redirectInfo: {
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      header: 'Weiterleiten',
      link: { text: 'Zu carigami.fr', url: 'https://www.carigami.fr' },
    },
  },
];

const useMockedMarketPicker = () => {
  // Use mock data in storybook / testing
  const [selectedMarket, setSelectedMarket] = useState(MARKETS[0]);
  return { selectedMarket, selectMarket: setSelectedMarket, markets: MARKETS };
};

export { MARKETS, useMockedMarketPicker };
